import { FilingWorkflowHistory } from "../../../../../../utilities/interfaces/FilingWorkflowHistory";

interface IFilingHistoryCardProps {
  history: FilingWorkflowHistory;
  key: any;
}

const FilingHistoryCard = (props: IFilingHistoryCardProps) => {
  const { history, key } = props;

  const notificationStatusIds = [19, 20, 21, 22, 29, 30];

  return (
    <div>
      {notificationStatusIds.includes(history.workflowStatusId) ? 
      (
        <div className="k-card" style={{marginTop: '10px', marginLeft: '50px'}}>
          <div className="k-card-body">
            <h5 className="k-card-title">{history.workflowStatusName}</h5>
            <h6 className="k-card-subtitle">{history.createdBy}</h6>
            <p>{history.createdOn.toString()}</p>
          </div>
        </div>  
      ) : 
      (
        <div className="k-card" style={{marginTop: '10px', backgroundColor: 'lightblue'}}>
          <div className="k-card-body">
            <h5 className="k-card-title">{history.workflowStatusName}</h5>
            <h6 className="k-card-subtitle">{history.createdBy}</h6>
            <p>{history.createdOn.toString()}</p>
          </div>
        </div>  
      )}
    </div>
  )
}

export default FilingHistoryCard;